import MptcfeUtils from 'mptcfe-utils'
let envMap = ['test', 'pre', 'prod'];
let enviromment = envMap.indexOf(window.deployEnv) > -1 ? window.deployEnv : MptcfeUtils.Utils.getEnvironment();
const isProd = enviromment == 'prod' || enviromment == 'pre'
const pugcBaseUrl = isProd ? '//v.aty.sohu.com' : '//test.aty.sohu.com'

export const getMad = (params) => {
    let url = pugcBaseUrl + '/mad'
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            type: "GET",
            data: params,
            dataType: "json",
            contentType: "application/json;charset=UTF-8",
            xhrFields: {
                withCredentials: true
            },
            success: (data) => {
                resolve(data);
            },
            error: (err) => {
                console.log(err);
                reject(err);
            }
        })
    })
}

export const getAd = (params) => {
    let url = pugcBaseUrl + '/v'
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            type: "GET",
            data: params,
            dataType: "json",
            contentType: "application/json;charset=UTF-8",
            xhrFields: {
                withCredentials: true
            },
            success: (data) => {
                resolve(data);
            },
            error: (err) => {
                console.log(err);
                reject(err);
            }
        })
    })
}